import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { TbCheck, TbX } from 'react-icons/tb';
import { DealerPendingActionTypes } from 'constants/DealerPendingActionTypes';
import { editDealerOrganization } from '../DealersActions';
import { DealerStatus } from '../../constants/DealerStatus';

function PendingActionButtons({ data, type, locationId }) {
  const dispatch = useDispatch();

  if (type === DealerPendingActionTypes.ADD_ADDITIONAL_LOCATION && locationId) {
    data = data.find((item) => item.value === locationId);
  }

  const pendingFunction = (status) => {
    dispatch(
      editDealerOrganization(data.id, {
        status,
        version: data.version,
      }),
    );
  };

  let newValue = '';

  if (
    type === DealerPendingActionTypes.MAIN_LOCATION_CHANGE &&
    typeof data?.value === 'object'
  ) {
    newValue = `${data?.value?.postalCode.postcode} | ${data?.value?.address} | ${
      data?.value?.address2 ? `${data?.value?.address2} |` : '(empty value) |'
    } ${data?.value?.city} | ${data?.value?.county}`;
  }

  if (type === DealerPendingActionTypes.PHONE_NUMBER_CHANGE) {
    newValue = data?.value;
  }

  if (type === DealerPendingActionTypes.LANDLINE_PHONE_NUMBER_CHANGE) {
    newValue = data?.value === null ? '-' : data?.value;
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {get(data, 'id', '') && (
        <div className="pending-action-buttons">
          {newValue && <p className="pending-action-value">{newValue}</p>}
          <div className="d-flex gap-1">
            <Button
              className="pending-action-button btn-success"
              type="button"
              onClick={() => pendingFunction(DealerStatus.ACTIVE)}
            >
              <TbCheck />
            </Button>
            <Button
              className="pending-action-button btn-danger"
              type="button"
              onClick={() => pendingFunction(DealerStatus.REJECTED)}
            >
              <TbX />
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

PendingActionButtons.defaultProps = {
  data: null,
  type: '',
  locationId: null,
};

PendingActionButtons.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  type: PropTypes.string,
  locationId: PropTypes.string,
};

export default PendingActionButtons;
